import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Search, X } from "lucide-react";
import { useApp } from "@/context/AppContext";
import api from "@/lib/api";

export default function SearchModal({ open, onClose }) {
  const { storefront, money } = useApp();
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!q || q.length < 2) { setResults([]); return; }
    const t = setTimeout(() => {
      api.get(`/search`, { params: { q, storefront } }).then((r) => setResults(r.data)).catch(() => {});
    }, 250);
    return () => clearTimeout(t);
  }, [q, storefront]);

  useEffect(() => { if (!open) { setQ(""); setResults([]); } }, [open]);

  const go = (p) => { onClose(); navigate(`/product/${p.slug}`); };

  return (
    <AnimatePresence>
      {open && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-[95]" style={{ background: "var(--ev-surface)" }} data-testid="search-modal">
          <div className="max-w-3xl mx-auto px-6 pt-16">
            <div className="flex items-center gap-4 border-b pb-4" style={{ borderColor: "var(--ev-text)" }}>
              <Search size={24} strokeWidth={1} />
              <input data-testid="search-input" autoFocus value={q} onChange={(e) => setQ(e.target.value)}
                placeholder="Search the Maison" className="flex-1 bg-transparent outline-none font-serif text-2xl" />
              <button data-testid="search-close" onClick={onClose}><X size={26} strokeWidth={1} /></button>
            </div>
            <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-6 max-h-[70vh] overflow-y-auto no-scrollbar">
              {results.map((p) => (
                <button key={p.id} data-testid={`search-result-${p.slug}`} onClick={() => go(p)} className="text-left group">
                  <div className="img-zoom aspect-[3/4] bg-ev-bg"><img src={(p.images || [])[0]} alt={p.name} className="w-full h-full object-cover" /></div>
                  <div className="mt-2 font-serif text-base">{p.name}</div>
                  <div className="text-xs uppercase tracking-wide" style={{ color: "var(--ev-muted)" }}>{p.storefront}</div>
                  <div className="text-sm">{money(p.sale_price_usd || p.price_usd)}</div>
                </button>
              ))}
              {q.length >= 2 && results.length === 0 && (
                <p className="col-span-full text-center py-10 font-serif text-xl" style={{ color: "var(--ev-muted)" }}>No pieces found for "{q}"</p>
              )}
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
